import React, { Fragment } from 'react';
import core from '@gin-betting/core';

import { SportEventSubscription } from 'components';
import useBetslipListSubscription from './useBetslipListSubscription';

const {
    utils: { splitMarketPath },
    async: {
        constants: { SubscribeOrigin },
    },
} = core;

const BetslipListSubscription: React.FC = () => {
    const { groupedMarketIdsByMatchId } = useBetslipListSubscription();

    return (
        <Fragment>
            {groupedMarketIdsByMatchId.map(([sportEventId, marketIds]) => (
                <SportEventSubscription
                    key={sportEventId}
                    variables={{
                        sportEventId,
                        marketIds: marketIds
                            .map(mId => splitMarketPath(mId)?.marketId)
                            .filter((m): m is string => Boolean(m))
                            .toArray(),
                        isTopMarkets: false,
                        withMarketsCount: false,
                    }}
                    origin={SubscribeOrigin.BetSlipList}
                    batch={false}
                />
            ))}
        </Fragment>
    );
};

export default BetslipListSubscription;
